// Populated from the X-CSRF-Token response header when the cookie is HttpOnly.
let csrfFromHeader: string | null = null;

export function rememberCsrfFromResponse(response: Response): void {
  const token = response.headers.get('X-CSRF-Token');
  if (token) csrfFromHeader = token;
}

export function installCsrfHeaderCapture(): void {
  if (typeof window === 'undefined' || (window as Window & { __csrfCapture?: boolean }).__csrfCapture) {
    return;
  }
  (window as Window & { __csrfCapture?: boolean }).__csrfCapture = true;
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    rememberCsrfFromResponse(response);
    return response;
  };
}

// Add the "export" keyword here
export function getCookie(name: string): string | null {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  if (cookieValue) return cookieValue;
  if (name === 'csrftoken') return csrfFromHeader;
  return null;
}

export function isPdfFilename(filename: string): boolean {
  return /\.pdf$/i.test((filename || '').trim());
}

/** Relative time for notification timestamps. */
export function formatRelativeTime(iso: string | Date): string {
  const then = typeof iso === 'string' ? new Date(iso) : iso;
  const now = new Date();
  const diffMs = now.getTime() - then.getTime();
  if (diffMs < 0) return 'Just now';

  const seconds = Math.floor(diffMs / 1000);
  if (seconds < 60) {
    return seconds <= 1 ? '1 second ago' : `${seconds} seconds ago`;
  }

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return minutes === 1 ? '1 min ago' : `${minutes} mins ago`;
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
  }

  const days = Math.floor(hours / 24);
  if (days === 1) return 'Yesterday';
  if (days === 2) return '2 days ago';
  return `${days} days ago`;
}

export const NOTIFICATIONS_REFRESH_EVENT = 'catalyx:notifications-refresh';

export function requestNotificationsRefresh(): void {
  window.dispatchEvent(new CustomEvent(NOTIFICATIONS_REFRESH_EVENT));
}